export default __webpack_public_path__ + "static/your_family_and_hATTR_amyloidosis-0628e233baba914dd9e4841e35268607.pdf";